import { visit } from 'unist-util-visit';
import type { Code, Root } from 'mdast';
import type { Properties } from 'hast';

interface HProps {
  hProperties?: Properties;
}

/**
 * Preserves the info string that follows the language on a fence, e.g.
 * ` ```ts title="setup.ts" `.
 *
 * `mdast-util-to-hast` drops `node.meta`, so it is copied onto the `code`
 * element where the renderer can read it.
 */
export default function remarkCodeMeta() {
  return (tree: Root) => {
    visit(tree, 'code', (node: Code) => {
      if (!node.meta) return;
      const data = (node.data ??= {}) as HProps;
      data.hProperties = { ...data.hProperties, dataMeta: node.meta };
    });
  };
}
